$(document).ready(function () {

  let JSShare = require('js-share');

  var shareItems = document.querySelectorAll('.social_share');
  JSShare.options.url = window.location.href;
  for (var i = 0; i < shareItems.length; i += 1) {
    shareItems[i].addEventListener('click', function share(e) {
      return JSShare.go(this);
    });
  }

});
